import React from 'react'

import {
  Box,
  Text,
  Color,
  FontWeight,
  Space,
  BorderStyle,
  Icon,
  Display,
  IconVariant,
  Link,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import configRoutes from 'config/routes'

const AccountOnHoldWrapper = withCitrusTheme(Box, () => ({
  marginTop: '43px',
  marginBottom: '-32px',
}))

export const AccountOnHoldAlert = () => (
  <AccountOnHoldWrapper>
    <Box
      bg={Color.Warning_50}
      borderColor={Color.Warning_100}
      borderWidth={1}
      borderStyle={BorderStyle.Solid}
      paddingH={4}
      paddingV={4}
      width="100%"
    >
      <Box display={Display.Flex}>
        <Icon name="warning" variant={IconVariant.Error} />
        <Space size={2} direction="horizontal" />
        <Box>
          <Text fontWeight={FontWeight.Bold}>Account on hold</Text>
          <Space size={2} direction="vertical" />
          <Text>
            Your account is currently on hold. Your future orders have been cancelled, and you
            won&apos;t be able to place any new ones until this is resolved. Please update your card
            details <Link href={`${configRoutes.client.myDetails}#paymentInfo`}>here</Link> to
            reactivate your account.
          </Text>
        </Box>
      </Box>
    </Box>
  </AccountOnHoldWrapper>
)
